import { isNode } from "@use/is-node";

/**
 * Wrapper around setTimeout that strongly types returned value.
 */
export function setTimeout(handler: () => unknown, timeout: number = 0): NodeJS.Timeout | number {
    return (
        isNode()
            ? global.setTimeout(handler, timeout)
            : window.setTimeout(handler, timeout)
    );
}
